(function () {
    'use strict';

    angular.module('app.routes')

        .config(function ($stateProvider) {

            $stateProvider

                .state('auth', {
                    abstract: true,
                    url: '/auth',
                    onEnter: function($rootScope){
                        $rootScope.bodyClass = 'login';
                    },
                    templateUrl: 'views/auth/index.html'
                })
                .state('auth.login', {
                    url: '/login',
                    views: {
                        '': {
                            templateUrl: 'views/auth/login.html',
                            controller: 'AuthLoginCtrl',
                            controllerAs: 'authvm'
                        },
                        // routes that do not require the user to be logged in are given a value of false
                        data: {
                            requireLogin: false
                        }
                    }
                })
                .state('auth.signup', {
                    url: '/signup',
                    views: {
                        '': {
                            templateUrl: 'views/auth/signup.html',
                            controller: 'AuthSignupCtrl',
                            controllerAs: 'authvm'
                        },
                        data: {
                            requireLogin: false
                        }
                    }
                })
                .state('auth.forgot', {
                    url: '/forgot',
                    views: {
                        '': {
                            templateUrl: 'views/auth/forgot.html',
                            controller: 'AuthForgotCtrl',
                            controllerAs: 'authvm'
                        },
                        data: {
                            requireLogin: false
                        }
                    }
                })

            ;

        })

    ;

})();